import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { Client, ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { FileTransferPayload } from 'src/app/models/FileTransferPayload';
import { EndUserCertification } from 'src/app/models/screeningInvite';
import { ClientPackagePricing } from 'src/app/packages-module/models/clientPackagePrice';
import { SearchPackage, VendorResponseTypes } from 'src/app/packages-module/models/searchPackage';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { AuthService } from 'src/app/services/auth.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { SearchPackageService } from 'src/app/services/search-package.service';
import { ScreeningDraftService } from '../../services/screening-draft.service';

@Component({
  selector: 'app-screening-batch-upload',
  templateUrl: './screening-batch-upload.component.html',
  styleUrls: ['./screening-batch-upload.component.less']
})
export class ScreeningBatchUploadComponent implements OnInit, OnDestroy {

  importErrors: string[] = [];
  fileLoaded: boolean = false;
  fileTransfer: FileTransferPayload = new FileTransferPayload();
  certification : EndUserCertification = new EndUserCertification();
  
  //dropdown bindings
  clientId: number;
  location: ClientLocation;
  packageId: number;
  sending: boolean = false;

  targetFile: any;
  $upload: Subscription;

  //fetching the latest data to make sure we have all the pieces necessary
  clientDD: Client[] = [];

  public get packageDD(): SearchPackage[] {
    return this.packages.searchPackages.filter(pkg =>{ return pkg.clientIds.includes(this.clientId) && !pkg.containsVerifications }).map((sp: SearchPackage) => {
      if (this.drafts.clientPackageOverrides) {
        const override = this.drafts.clientPackageOverrides.find(spo => {
          return spo.searchPackageId === sp.id;
        });
        if (override) {
          sp.cost = override.clientPackageCost;
        }
      }
      return sp;
    });
  }
  public get locationDD(): ClientLocation[] {
    if(!this.props.properties) return [];
    return this.props.activeProperties;
  }

  constructor(public auth : AuthService, public toast : ToastrService, private fileUpload: FileUploadService, private fileDownload: FileDownloadService,
    public props: PropertyService, public clients: ClientService, public packages: SearchPackageService, private drafts : ScreeningDraftService, private router: Router) { }
  
    ngOnDestroy(): void {
    if(this.$upload) this.$upload.unsubscribe();
  }

  ngOnInit(): void {

    //Kick off the loading calls to populate the DDs
    //MAKE SURE THE RESULTS ARE NOT PAGINATED!!!!!!!!!!
    this.clients.FetchLightClientList().pipe(
      tap(_ => {
        this.clientDD = _.filter(c=>{return c.isActive;});
      })
    ).subscribe();
  }

  goBack(): void {

    this.router.navigateByUrl('/screenings');
  }

  clientChange() {

    this.location = undefined;
    this.packageId = undefined;
    this.props.FetchPropertiesForClient(this.clientId);

    this.packages.FetchFullSearchPackagesListForUser(this.clientId);
    this.packages.GetClientSearchPackageOverrideList(this.clientId)
    .pipe(
      take(1),
      tap((scc: ClientPackagePricing[]) => {
        this.drafts.clientPackageOverrides = scc;
    })).subscribe(null,(err: any)=>{
        this.toast.error('Error Fetching Search Package List');
    });
  }

  handleFile($event: Event) {
    this.fileLoaded = false;
    this.fileUpload.handleFileUpload($event, this.clientId, this.auth.loggedInUser.id).pipe(
      tap(_ => {
       this.fileTransfer = _;
       this.fileLoaded = true; 
      })
    ).subscribe();
  }

  public uploadFile() : void {
    if(this.$upload) this.$upload.unsubscribe();
    this.importErrors = [];
    if(this.targetFile == null) return;
    if(!this.clientId || !this.packageId || !this.location) {
      let msg = 'Please ensure you select a client, location, and package from the dropdown menus.'
      this.toast.error(msg, 'Processing Error', { closeButton: true, disableTimeOut: true });
      this.importErrors.push(msg);
      return;
    }
    if(!this.certification.ec || !this.certification.pp) {
      let ecMsg: string = 'Please review the consent agreements and certify by clicking both checkboxes.';
      this.toast.error(ecMsg, 'Processing Error', { closeButton: true, disableTimeOut: true });
      this.importErrors.push(ecMsg);
      return;
    }
    this.sending = true;
    this.fileTransfer.packageId = this.packageId;
    this.fileTransfer.clientId = this.clientId;
    this.fileTransfer.locations = [];
    this.fileTransfer.locations.push(this.location);
    this.toast.info('Uploading batch file!', '');
    this.$upload = this.fileUpload.UploadScreeningBatchFile(this.fileTransfer).subscribe((res : string[] )=> {
      this.importErrors = res;
      if(this.importErrors && this.importErrors.length > 0) this.toast.warning('Some screenings failed validation. No screenings were imported.', '', { closeButton: true, disableTimeOut: true })
      else this.toast.success('Screenings successfully imported!', '');
    },
    error => {
      this.toast.error('Error uploading selected file. No screenings were imported.');
      this.sending = false;
    },
    () => {
      this.sending = false;
      this.targetFile = null;
      this.$upload = null;
    })
  }

  public downloadTemplate(): void {
    this.fileDownload.DownloadScreeningBatchTemplate().pipe(
      tap(_ => {
        this.fileDownload.HandleFileDownload(_, 'test/csv', 'ScreeningBatchUpload.csv');
      },
      err => {
        this.toast.error('Error downloading file template!');
      },
      () => {
        this.toast.success('Template downloaded!');
      })
    ).subscribe()
  }
}
